import React, { useEffect, useRef } from 'react';
import '../Home.css';

const albums = [
  { title: 'Future Nostalgia', artist: 'Dua Lipa', cover: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=400&q=80' },
  { title: 'After Hours', artist: 'The Weeknd', cover: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=400&q=80' },
  { title: 'Divide', artist: 'Ed Sheeran', cover: 'https://upload.wikimedia.org/wikipedia/en/4/45/Divide_cover.png' },
  { title: 'When We All Fall Asleep', artist: 'Billie Eilish', cover: 'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=400&q=80' },
  { title: 'Random Access Memories', artist: 'Daft Punk', cover: 'https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=crop&w=400&q=80' },
  { title: 'AM', artist: 'Arctic Monkeys', cover: 'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=400&q=80' },
  { title: 'Fine Line', artist: 'Harry Styles', cover: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=400&q=80' },
  { title: 'Lover', artist: 'Taylor Swift', cover: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=400&q=80' },
  { title: 'Justice', artist: 'Justin Bieber', cover: 'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=400&q=80' },
  { title: "Hollywood's Bleeding", artist: 'Post Malone', cover: 'https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=crop&w=400&q=80' },
  { title: 'SOUR', artist: 'Olivia Rodrigo', cover: 'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=400&q=80' },
  { title: 'Scorpion', artist: 'Drake', cover: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=400&q=80' },
  { title: 'Random Album 1', artist: 'Unknown Artist', cover: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=400&q=80' },
  { title: 'Random Album 2', artist: 'Unknown Artist', cover: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=400&q=80' },
  { title: 'Random Album 3', artist: 'Unknown Artist', cover: 'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=400&q=80' },
];

const artists = [
  { name: 'Ed Sheeran', photo: 'https://randomuser.me/api/portraits/men/32.jpg' },
  { name: 'The Weeknd', photo: 'https://randomuser.me/api/portraits/men/41.jpg' },
  { name: 'Dua Lipa', photo: 'https://randomuser.me/api/portraits/women/44.jpg' },
  { name: 'Billie Eilish', photo: 'https://randomuser.me/api/portraits/women/68.jpg' },
  { name: 'Daft Punk', photo: 'https://images.unsplash.com/photo-1511367461989-f85a21fda167?auto=format&fit=facearea&w=400&q=80' },
  { name: 'Arctic Monkeys', photo: 'https://randomuser.me/api/portraits/men/76.jpg' },
  { name: 'Taylor Swift', photo: 'https://randomuser.me/api/portraits/women/65.jpg' },
  { name: 'Harry Styles', photo: 'https://randomuser.me/api/portraits/men/55.jpg' },
  { name: 'Justin Bieber', photo: 'https://randomuser.me/api/portraits/men/88.jpg' },
  { name: 'Post Malone', photo: 'https://randomuser.me/api/portraits/men/22.jpg' },
  { name: 'Olivia Rodrigo', photo: 'https://randomuser.me/api/portraits/women/12.jpg' },
  { name: 'Drake', photo: 'https://randomuser.me/api/portraits/men/77.jpg' },
];

const genres = [
  { name: 'Pop', icon: '🎤' },
  { name: 'Rock', icon: '🎸' },
  { name: 'Metal', icon: '🤘' },
  { name: 'Electro', icon: '🎧' },
  { name: 'Hip-Hop', icon: '🎤' },
  { name: 'Jazz', icon: '🎷' },
  { name: 'Indie', icon: '🌈' },
  { name: 'Folk', icon: '🪕' },
];

const users = [
  { pseudo: 'Sarah', avatar: 'https://randomuser.me/api/portraits/women/44.jpg', contribs: 152 },
  { pseudo: 'Yassine', avatar: 'https://randomuser.me/api/portraits/men/41.jpg', contribs: 140 },
  { pseudo: 'Julie', avatar: 'https://randomuser.me/api/portraits/women/23.jpg', contribs: 133 },
];

const stats = [
  { label: 'Utilisateurs', value: 1240, icon: '👥' },
  { label: 'Morceaux', value: 320, icon: '🎵' },
  { label: 'Albums', value: 210, icon: '💿' },
  { label: 'Commentaires', value: 542, icon: '💬' },
];

const news = [
  { title: "Lancement de la nouvelle encyclopédie musicale !", date: "2024-06-01", img: 'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=400&q=80', text: "Découvrez la nouvelle plateforme communautaire pour référencer, noter et partager vos morceaux préférés !" },
  { title: "Ajout de nouveaux genres musicaux.", date: "2024-05-28", img: 'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=400&q=80', text: "La base de données s'enrichit avec encore plus de diversité musicale." },
];

const comments = [
  { user: 'Sarah', text: "J'adore ce morceau !", track: 'Shape of You', avatar: 'https://randomuser.me/api/portraits/women/44.jpg' },
  { user: 'Yassine', text: "Le refrain reste en tête !", track: 'Blinding Lights', avatar: 'https://randomuser.me/api/portraits/men/41.jpg' },
];

function StatCounter({ value, label, icon }: { value: number, label: string, icon: string }) {
  const ref = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    let start = 0;
    const end = value;
    const duration = 900;
    const step = Math.ceil(end / 40);
    let current = start;
    const el = ref.current;
    if (!el) return;
    el.textContent = '0';
    const interval = setInterval(() => {
      current += step;
      if (current >= end) {
        el.textContent = end.toString();
        clearInterval(interval);
      } else {
        el.textContent = current.toString();
      }
    }, duration / (end / step));
    return () => clearInterval(interval);
  }, [value]);
  return (
    <div className="stat-card">
      <span className="stat-icon">{icon}</span>
      <span className="stat-value" ref={ref}>0</span>
      <span className="stat-label">{label}</span>
    </div>
  );
}

export default function Home() {
  return (
    <div className="home-root">
      {/* WOW BANNER ANIMATED */}
      <div className="wow-banner-animated"></div>
      {/* HERO */}
      <section className="hero">
        <div className="hero-overlay">
          <h1>Encyclopédie Musicale</h1>
          <p>Découvrez, partagez et vibrez avec la plus grande base communautaire de musique moderne.</p>
          <a href="#albums" className="cta-btn">Explorer les albums</a>
        </div>
      </section>

      {/* STATS */}
      <section className="stats-section">
        <div className="stats-grid">
          {stats.map((s, i) => (
            <StatCounter key={i} value={s.value} label={s.label} icon={s.icon} />
          ))}
        </div>
      </section>

      {/* ALBUMS CAROUSEL */}
      <section className="albums-section" id="albums">
        <h2>Nouveaux albums</h2>
        <div className="albums-carousel">
          {albums.map((a, i) => (
            <div className="album-card" key={i}>
              <img src={a.cover} alt={a.title} />
              <div className="album-info">
                <strong>{a.title}</strong>
                <span>{a.artist}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ARTISTS GRID */}
      <section className="artists-section">
        <h2>Artistes populaires</h2>
        <div className="artists-grid">
          {artists.map((a, i) => (
            <div className="artist-card" key={i}>
              <img src={a.photo} alt={a.name} />
              <span>{a.name}</span>
            </div>
          ))}
        </div>
      </section>

      {/* GENRES */}
      <section className="genres-section">
        <h2>Genres à explorer</h2>
        <div className="genres-list">
          {genres.map((g, i) => (
            <span className="genre-tag" key={i}>
              <span className="genre-icon">{g.icon}</span> {g.name}
            </span>
          ))}
        </div>
      </section>

      {/* COMMUNITY */}
      <section className="community-section">
        <h2>Top utilisateurs</h2>
        <div className="users-grid">
          {users.map((u, i) => (
            <div className="user-card" key={i}>
              <img src={u.avatar} alt={u.pseudo} />
              <div>
                <strong>{u.pseudo}</strong>
                <span>{u.contribs} contributions</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* NEWS */}
      <section className="news-section">
        <h2>News & Événements</h2>
        <div className="news-grid">
          {news.map((n, i) => (
            <div className="news-card" key={i}>
              <img src={n.img} alt={n.title} />
              <div className="news-info">
                <span className="news-date">{n.date}</span>
                <strong>{n.title}</strong>
                <p>{n.text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* COMMENTS SLIDER */}
      <section className="comments-section">
        <h2>Commentaires récents</h2>
        <div className="comments-slider">
          {comments.map((c, i) => (
            <div className="comment-card" key={i}>
              <img src={c.avatar} alt={c.user} />
              <div>
                <strong>{c.user}</strong> sur <em>{c.track}</em>
                <p>{c.text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div>© 2024 Encyclopédie Musicale - Tous droits réservés</div>
        <div className="footer-links">
          <a href="#">Contact</a> | <a href="#">À propos</a> | <a href="#">Mentions légales</a>
        </div>
        <div className="footer-socials">
          <a href="#"><img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/instagram.svg" alt="Instagram" /></a>
          <a href="#"><img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/twitter.svg" alt="Twitter" /></a>
          <a href="#"><img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/facebook.svg" alt="Facebook" /></a>
        </div>
      </footer>
    </div>
  );
} 